import { MenuListModel } from '../models/menu.model'

export const LISTROUTES: MenuListModel[] = [
  {
    type: 'title',
    label: 'Home',
    // route: 'dashboard',
    route: 'home',
    permission: 'view-tipo-contato',
  },
  {
    type: 'subTitle',
    label: 'Cadastro',
    children: [
      {
        label: 'Banco',
        route: 'banco',
        permission: 'view-banco',
      },
      {
        label: 'Especificações Serviço',
        route: 'especificacao-servico',
        permission: 'view-serviço',
      },
      {
        label: 'Função Funcionário',
        route: 'funcao-funcionario',
        permission: 'view-função-funcionário',
      },
      {
        label: 'Localização',
        route: 'localizacao',
        permission: 'view-origem-destino',
      },
      {
        label: 'Modelo Veículo',
        route: 'modelo-veiculo',
        permission: 'view-modelo-veículo',
      },
      {
        label: 'Perfil',
        route: 'perfil',
        permission: 'view-perfil',
      },
      {
        label: 'Serviço adicional',
        route: 'servico-adicional',
        // permission: 'hide',
        permission: 'view-serviço-adicional',
        // permission: 'view-banco',
      },
      {
        label: 'Tarifário',
        route: 'tarifario',
        // permission: 'hide',
        permission: 'view-tarifário',
        // permission: 'view-banco',
      },
      {
        label: 'Importação Tarifário',
        route: 'importacao-tarifario',
        // permission: 'hide',
        permission: 'view-tarifário',
        // permission: 'view-banco',
      },
      {
        label: 'Veículo',
        route: 'veiculos',
        permission: 'view-serviço',
      },
      {
        label: 'Ocorrências',
        route: 'ocorrencias',
        permission: 'view-serviço',
      },
      {
        label: 'Motivos',
        route: 'motivos',
        // permission: 'view-tarifário',
        permission: 'view-motivos',
      },
      {
        label: 'Gerenciamento Usuários',
        route: 'gerenciamento-usuarios',
        // permission: 'view-tarifário',
        permission: 'view-serviço-adicional',
      },
    ],
  },
  {
    type: 'subTitle',
    label: 'Cadastrar Tipos',
    children: [
      {
        label: 'Contato',
        route: 'tipo-contato',
        permission: 'view-tipo-contato',
      },
      {
        label: 'Documento',
        route: 'tipo-documento',
        permission: 'view-tipo-documento',
      },
      {
        label: 'Documento Fiscal',
        route: 'tipo-documento-fiscal',
        permission: 'view-tipo-documento-fiscal',
      },
      {
        label: 'Endereço',
        route: 'tipo-endereco',
        permission: 'view-tipo-endereço',
      },
      {
        label: 'Motorista',
        route: 'tipo-motorista',
        permission: 'view-tipo-motorista',
      },
      {
        label: 'Ocorrência',
        route: 'tipo-ocorrencia',
        permission: 'view-tipo-ocorrência',
      },
      {
        label: 'Pagamento',
        route: 'tipo-pagamento',
        permission: 'view-tipo-pagamento',
      },
      // {
      //   label: 'Pessoa',
      //   route: 'tipo-pessoa',
      //   permission: 'view-tipo-pessoa',
      // },
      {
        label: 'Serviço',
        route: 'tipo-servico',
        permission: 'view-tipo-serviço',
      },
      {
        label: 'Tarifário',
        route: 'tipo-tarifario',
        permission: 'view-tipo-tarifário',
      },
      {
        label: 'Trecho',
        route: 'tipo-trecho',
        permission: 'view-tipo-tarifário',
        // permission: 'view-tipo-trecho',
      },
      {
        label: 'Veículo',
        route: 'tipo-veiculo',
        permission: 'view-tipo-veículo',
      },
    ],
  },
  {
    type: 'subTitle',
    label: 'Status',
    children: [
      {
        label: 'Contrato',
        route: 'status-contrato',
        permission: 'view-status-contrato',
      },
      {
        label: 'Cotação',
        route: 'status-cotacao',
        permission: 'view-status-cotação',
      },
      {
        label: 'Funcionário',
        route: 'status-funcionario',
        permission: 'view-status-funcionário',
        // permission: 'hide',
        // permission: 'view-status-operação',
      },
      {
        label: 'Operação',
        route: 'status-operacao',
        permission: 'view-status-operação',
      },
      {
        label: 'Proposta',
        route: 'status-proposta',
        // permission: 'view-serviço',
        permission: 'view-status-proposta',
      },
    ],
  },
  {
    type: 'subTitle',
    label: 'Pessoa',
    children: [
      {
        label: 'Cliente',
        route: 'cliente',
        // permission: 'view-tipo-contato',
        permission: 'view-clientes-pessoa-juridica',
        // permission: ['view-clientes-pessoa-juridica','view-sub-clientes','view-consultores-clientes'],
      },
      {
        label: 'Fornecedor',
        route: 'fornecedor',
        permission: 'view-fornecedor',
        // permission: 'hide',
        // permission: 'view-status-operação',
      },
      {
        label: 'Funcionário',
        route: 'funcionario',
        permission: 'view-funcionário',
        // permission: 'hide',
        // permission: 'view-status-operação',
      },
      {
        label: 'Motorista',
        route: 'motorista',
        permission: 'view-motorista',
        // permission: 'hide',
        // permission: 'view-status-operação',
      },
    ],
  },
  {
    type: 'subTitle',
    label: 'Proposta',
    children: [
      {
        label: 'Proposta Cliente',
        route: 'proposta-cliente',
        // permission: 'view-serviço',
        permission: 'view-proposta-cliente',
      },
      {
        label: 'Solicitação Cotação',
        route: 'solicitacao-cotacao',
        permission: 'view-compras',
        // permission: 'view-solicitacao-cotacao',
      },
      {
        label: 'Cotação Fornecedor',
        route: 'cotacao-fornecedor',
        // permission: 'view-serviço',
        permission: 'view-compras',
        // permission: 'view-cotacao-fornecedor',
      },
    ],
  },
  {
    type: 'subTitle',
    label: 'Contratos',
    children: [
      {
        label: 'Contrato Cliente',
        route: 'contrato-cliente',
        permission: 'view-contrato-cliente',
      },
    ],
  },
  {
    type: 'subTitle',
    label: 'Operação',
    children: [
      {
        label: 'Logística',
        route: 'logistica',
        permission: 'view-serviço',
        // permission: 'view-logistica',
      },
      {
        label: 'Ordem de Serviço',
        route: 'ordem-servico',
        permission: 'view-serviço',
        // permission: 'view-ordem-servico',
      },
      {
        label: 'Agenda Frota',
        route: 'agenda-frota',
        permission: 'view-serviço',
      },
      {
        label: 'Compras',
        route: 'compras',
        permission: 'view-serviço',
        // permission: 'view-compras',
      },
      {
        label: 'Monitoramento Frota',
        route: 'monitoramento-frota',
        permission: 'view-serviço',
      },
    ],
  },
  // {
  //   type: 'subTitle',
  //   label: 'Financeiro',
  //   children: [
  //     {
  //       label: 'Operação',
  //       route: 'financeiro-operacao',
  //       permission: 'view-serviço',
  //     },
  //   ],
  // },
]
